import {
    add,
    addDays,
    format,
    formatISO,
    getDate,
    isValid as isDateValid,
    parse,
    parseISO,
    setISODay,
    startOfDay,
    sub,
} from "date-fns";

export {isDateValid, startOfDay, addDays};

export const getDateString = (date: Date): string =>
    formatISO(date, { representation: `date` });

export const parseDateString = (dateString: string): Date =>
    parseISO(dateString);

export const getTodayDate = (): string => getDateString(new Date());

export const mapDate = (mapFn: (date: Date) => Date) => (
    date: string,
): string => getDateString(mapFn(parseISO(date)));

export const getWeekDayDate = (weekday: number): ((date: string) => string) =>
    mapDate((d) => setISODay(d, weekday));

export const MONDAY_WEEK_DAY = 1;

export const getMonday = getWeekDayDate(MONDAY_WEEK_DAY);

export const getPreviousWeek = mapDate((d) => sub(d, { weeks: 1 }));

export const getNextWeek = mapDate((d) => add(d, { weeks: 1 }));

export const getMonthName = (date: string): string =>
    format(parseISO(date), `MMMM`);

export const getHours = (minutes: number): number => ((minutes / 60) | 0) % 24;

export const getMinutes = (minutes: number): string =>
    (minutes % 60).toString().padStart(2, `0`);

export const formatTime = (minutes: number): string =>
    `${getHours(minutes)}:${getMinutes(minutes)}`;

export const getMinutesFromDate = (dateTime: Date, date: string): number =>
    (() => {
        const day = parseISO(date);
        const dayDelta = Math.round(
            (Date.UTC(
                dateTime.getFullYear(),
                dateTime.getMonth(),
                dateTime.getDate(),
            ) -
                Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())) /
                86400000,
        );
        return dayDelta * 1440 + dateTime.getHours() * 60 + dateTime.getMinutes();
    })();

// inverse of getMinutesFromDate: minutes-since-midnight of `date` -> ISO datetime
export const getDateTimeFromMinutes = (date: string, minutes: number): string =>
    (() => {
        const day = parseISO(date);
        return getDateTimeString(
            new Date(
                day.getFullYear(),
                day.getMonth(),
                day.getDate(),
                0,
                minutes,
            ),
        );
    })();

export const getDay = (date: string): number => getDate(parseISO(date));

// const dateTimeFormat = `yyyyMMddHHmmssSSS`;
export const getDateTimeString = (date: Date): string =>
    formatISO(date);
    // format(date, dateTimeFormat);

export const parseDateTimeString = (dateString: string): Date =>
    parseISO(dateString);
    // parse(dateString, dateTimeFormat, new Date());
